import { Component, OnInit } from "@angular/core";
import { timer } from "rxjs";
import { UserService } from "../../../../shared";
import { MenuService } from "../../services";

@Component({
	selector: "caass-broadcast-messages",
	templateUrl: "./broadcast-messages.component.html",
	styleUrls: ["./broadcast-messages.component.css"],
})
export class BroadcastMessagesComponent implements OnInit {
	constructor(private userService: UserService, private menuService: MenuService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadBroadcastAlerts();
	}

	ngOnDestory() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////
	// Data
	//////////////////////////////
	RefreshMinutes: any = -1;
	user: any;
	lstBroadcastAlerts: any = [];

	refreshing: boolean = false;

	subscription: any;
	//////////////////////////////

	//////////////////////////////
	// Load Data
	//////////////////////////////
	loadBroadcastAlerts() {
		var result = this.menuService.BroadcastAlertTodaySelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstBroadcastAlerts = response;
				this.loadRefreshMinutes();
			},
			(error) => {}
		);
	}

	loadRefreshMinutes() {
		var result = this.menuService.GetAlertsRefreshMinutes();
		result.subscribe(
			(response) => {
				this.RefreshMinutes = response[0];

				this.RefreshData();
			},
			(error) => {
				this.RefreshMinutes = 3;

				this.RefreshData();
			}
		);
	}

	async RefreshData() {
		if (!this.refreshing) {
			this.refreshing = true;
			var ms = this.RefreshMinutes * 1000 * 60;

			this.subscription = timer(ms, ms).subscribe((x) => {
				this.loadBroadcastAlerts();
			});
		}
	}

	//////////////////////////////

	//////////////////////////////
	// Helpers
	//////////////////////////////

	GetClass(val) {
		return "Message" + ((val % 10) + 1);
		// var randomNum = Math.floor(Math.random() * 10);
		// return "Message" + ((randomNum % 10) + 1);
	}

	//////////////////////////////
}
